import * as React from 'react'

const SvgArrowUpRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 3.75V5h7.869L3.75 15.369l.881.881L15 5.881v7.869h1.25v-10h-10z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowUpRightIcon
